import { useCallback } from 'react'
import { PreparationMode } from '@/api'
import { useUserUiPreferences } from '@/hooks/use-user-ui-preferences'

/** Préparation présélectionnée, rangée dans les préférences d'interface (`defaultPreparation`). */
export function useDefaultPreparation() {
  const { preferences, hydrated, update: updatePreferences } = useUserUiPreferences()

  const update = useCallback(
    async (next: PreparationMode) => {
      await updatePreferences({ defaultPreparation: next })
    },
    [updatePreferences]
  )

  return { mode: preferences.defaultPreparation, loaded: hydrated, update }
}
